import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { fromUnitsToRem, YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const CustomContentCardStyle: SxProps<Theme> = {
  padding: '1rem',
  border: 'none',
  borderRadius: YodaBorderRadius.small,
};

export const TacticChannelGroupStyle: SxProps<Theme> = {
  textAlign: 'left',
  mr: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'auto',
  height: '20px',
  borderRadius: YodaBorderRadius.xSmall,
  color: YodaColors.white,
  fontSize: YodaFontSize.small,
  paddingLeft: YodaSpacing.xxSmall,
  paddingRight: YodaSpacing.xxSmall,
  paddingTop: YodaSpacing.xxxxSmall,
  paddingBottom: YodaSpacing.xxxxSmall,
};

export const TacticCardVeevaStatusStyle: SxProps<Theme> = {
  textAlign: 'right',
  ml: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'auto',
  height: '20px',
  borderRadius: YodaBorderRadius.xSmall,
  fontSize: YodaFontSize.small,
  paddingLeft: YodaSpacing.xxSmall,
  paddingRight: YodaSpacing.xxSmall,
  paddingTop: YodaSpacing.xxxxSmall,
  paddingBottom: YodaSpacing.xxxxSmall,
};

export const navigationRowStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: YodaSpacing.small,
};

export const labelsWrapperStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  gap: YodaSpacing.xxSmall,
};

export const TacticGroupBoxStyle: SxProps<Theme> = {
  ...TacticChannelGroupStyle,
  marginRight: 0,
};

export const TacticCardTitleStyle: SxProps<Theme> = {
  marginBottom: YodaSpacing.xxSmall,
  fontSize: YodaFontSize.small,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  wordWrap: 'break-word',
  color: YodaColors.textPrimary,
  fontWeight: 'bold',
};

export const TacticCardInnerStyle: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  color: YodaColors.textPrimary,
  gap: YodaSpacing.xxSmall,
};

export const TacticCardSeparatorStyle: SxProps<Theme> = {
  borderLeft: `1px solid ${YodaColors.gray5}`,
  flexShrink: 0,
  height: '16px',
};

export const TacticCardFontStyle: SxProps<Theme> = {
  fontSize: YodaFontSize.xSmall,
  marginBottom: YodaSpacing.xxxSmall,
};

export const clickableIdStyle: SxProps<Theme> = {
  display: 'flex',
  gap: YodaSpacing.xxSmall,
  fontSize: YodaFontSize.xSmall,
  marginBottom: YodaSpacing.xxxSmall,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  wordWrap: 'break-word',
};

export const clickableIdTitleStyle: SxProps<Theme> = {
  maxWidth: '130px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const clickableIdIconStyle: SxProps<Theme> = {
  '&:hover': {
    cursor: 'pointer',
  },
};

export const iconsStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'end',
  gap: '17px',
  color: YodaColors.white,

  '& > *:hover': {
    cursor: 'pointer',
  },

  '& .MuiSvgIcon-root': {
    maxWidth: '20px',
    maxHeight: '20px',
    backgroundColor: YodaColors.primaryBlue,
    padding: '5px',
    borderRadius: '20px',
  },

  '& .MuiSvgIcon-root:hover': {
    cursor: 'pointer',
    backgroundColor: YodaColors.primaryBlueHover,
  },
};

export const tacticGroupIconStyle: SxProps<Theme> = {
  fontSize: YodaFontSize.xSmall,
};

export const StepMoveToDropdownStyles: SxProps<Theme> = {
  '.MuiMenu-list': {
    maxHeight: '356px',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: 0,
  },

  '.MuiMenu-list > .MuiBox-root': {
    minWidth: '190px',
  },

  '.MuiPaper-root': {
    maxWidth: '190px',
    borderRadius: YodaBorderRadius.small,
    color: YodaColors.black,
    marginTop: fromUnitsToRem(YodaSpacing.xxSmall),
    overflow: 'visible',
    boxShadow: '0px -3px 20px 0px rgba(64, 83, 110, 0.3)',
  },

  '.MuiMenuItem-root': {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    lineHeight: '1.3',
    alignItems: 'flex-start',
    display: 'flex',

    '& .MuiBox-root': {
      color: YodaColors.textPrimary,
      fontSize: YodaFontSize.small,
      fontWeight: YodaFontWeight.regular,
    },

    '&:first-of-type': {
      borderTopLeftRadius: YodaBorderRadius.small,
      borderTopRightRadius: YodaBorderRadius.small,
    },

    '&:last-of-type': {
      borderBottomLeftRadius: YodaBorderRadius.small,
      borderBottomRightRadius: YodaBorderRadius.small,
    },
  },
};

export const TacticDeleteButtonStyle = (isDisabledTacticDeleting: boolean): SxProps<Theme> => ({
  cursor: isDisabledTacticDeleting ? 'not-allowed' : 'auto',
  pointerEvents: isDisabledTacticDeleting ? 'none' : 'auto',
});
